<p-dialog
  [closable]="true"
  [closeOnEscape]="false"
  [draggable]="false"
  [focusOnShow]="false"
  [maskStyleClass]="'dialog-mask'"
  [modal]="true"
  [styleClass]="'feedback-survey-modal overlay-md'"
  [(visible)]="visible"
  (onHide)="onDialogHide(true)">
  <ng-template pTemplate="header">
    <!-- disable eslint ngSrc warning because it does not support blob images: -->
    <!-- eslint-disable-next-line @angular-eslint/template/prefer-ngsrc -->
    <img alt="descrição" [src]="'assets/feedback-survey-img.svg'" />
  </ng-template>

  <ng-template pTemplate="content">
    <h1>{{ 'general_feedback.title' | translate }}</h1>

    <p [innerHTML]="'general_feedback.text' | translate"></p>

    <div class="flex justify-content-end align-items-center gap-2">
      <button pButton pRippe rounded severity="secondary" type="button" (click)="remindLater()">
        {{ 'general_feedback.remind-later-btn' | translate }}
      </button>
      <button pButton pRippe rounded severity="primary" type="button" (click)="answerSurvey()">
        {{ 'general_feedback.answer-btn' | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      label="{{ 'general_feedback.dismiss-btn' | translate }}"
      [link]="true"
      [style]="{ textDecoration: 'underline', color: 'var(--genuz-textColor-secondary)' }"
      (click)="decline()" />
  </ng-template>
</p-dialog>
